import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";

// YOUR WEB APP'S FIREBASE CONFIGURATION
const firebaseConfig = {
	  apiKey: "AIzaSyDgWiCqS6k3X7BS2UmYtpLDd94T3ThtzJg",
	  authDomain: "apxtripp.firebaseapp.com",
	  projectId: "apxtripp",
	  storageBucket: "apxtripp.appspot.com",
	  messagingSenderId: "76302867458",
	  appId: "1:76302867458:web:7cd730cc7da7530a855b1b"
};


export const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);

